import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPostsById } from "../../../../../redux/posts/action";
import getTimeDifference from "../../../../Common/TimeDifference";
import {
  formatNumberWithCommas,
  getMemberSince,
  getPosttype
} from "../../../../Common/AllDateTimeReleventFormate";
import CustomReactQuillDescription from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import CustomeCategoryandSubcategory from "../../../../Common/CustomeLabel/CustomeCategoryandSubcategory";
import DeadlineComponents from "../../../../Common/DeadlineComponents";

export default function ProjectOffers() {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const path = "Assets/scss/FindWork.module.scss";
  const { id } = useParams();
  const posts = useSelector(({ posts: { postbyid } }) => postbyid);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPostsById(id));
  }, [id]);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const navigate = useNavigate();

  return (
    <div className="project-offer project-details col-lg-10 mx-auto">
      <p className="breadcrumbs">
        <a onClick={() => navigate(`/${lan}/searchall`)}>Home &gt; </a>
        <a onClick={() => navigate(`/${lan}/projectdetails/${posts.id}`)}>
          Post details &gt;
        </a>
        Send offer
      </p>
      <div className="row">
        <div className="col-md-9">
          <div className="post-details">
            <h2>Congratulation 🎉, You received an offer</h2>
            <div className="filter-detail">
              <div>
                <h5>
                  {posts.title} <span className="project">{getPosttype(posts.type)}</span>
                </h5>
                <div className="dollar-sec">
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/dollar.svg`}
                      alt=""
                    /> Budget
                     : SAR {formatNumberWithCommas(posts.price)}
                  </p>
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/hourglass.svg`}
                      alt=""
                    />
                    <DeadlineComponents posts={posts} />
                  </p>
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/message.svg`}
                      alt=""
                    />
                    Posted:{getTimeDifference(posts?.created_on)}
                  </p>
                </div>
                <CustomeCategoryandSubcategory  posts={posts} />
                <CustomReactQuillDescription value={posts.description} />
                <div className="photoshop">
                  {Array.isArray(posts?.skills) &&
                    posts?.skills.map((item1, index1) => (
                      <p key={index1}>{item1.title}</p>
                    ))}
                </div>
                <div className="proposal">
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/proposal.svg`}
                      alt=""
                    />
                    Proposal: {posts.proposal_count || 0}
                  </p>
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/location.svg`}
                      alt=""
                    />
                    Location: Riyadh
                  </p>
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/payment.svg`}
                      alt=""
                    />
                    Verified Payment
                  </p>
                </div>
              </div>
              <button
                onClick={() => navigate(`/${lan}/projectdetails/${posts.id}`)}
                className="btn view-post"
              >
                View post
              </button>
            </div>
            {/* <div className="lang-sec">
              <h6>Client’s message</h6>
              <p>Under the direction of the CEO, the Digital Media Coordinator will create and implement all graphic design across all Glow Collection digital properties. The Digital Marketing Coordinator will also be responsible for the content creation and community management for all Glow Collection Social Media properties (Facebook, Twitter, TikTok, Pinterest, Instagram and YouTube). They will also be responsible for the management and optimisation of all email marketing campaigns using Klaviyo. They will also be responsible for the UI and product merchandising of the Glow Collection Shopify site.
                <span>Adobe illustrator and usage of AI design programs.</span>
                <span>Advanced HTML coding</span>
                <span>Advanced video editing and production skills - with particular reference to social media media</span>
                <span>Advanced knowledge of all social platforms</span>
                <span>Advanced selling skills</span>
                <span>Advanced knowledge of Shopify and plug in apps</span>
                <span>Expert knowledge of Klaviyo</span>
              </p>
            </div> */}
            <div className="lang-sec">
              <h6>Agreed Milestones</h6>
              <div className="table-responsive">
                <table className="table ">
                  <thead>
                    <th>Milestones</th>
                    <th>Deadline</th>
                    <th>Amount</th>
                    <th>
                      Penalty
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/project/penalty.svg`}
                        alt=""
                      />
                    </th>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1. Sketch and concept</td>
                      <td>2 day</td>
                      <td>SAR 100</td>
                      <td>2%</td>
                    </tr>
                    <tr>
                      <td>2. Sketch and concept</td>
                      <td>2 day</td>
                      <td>SAR 100</td>
                      <td>2%</td>
                    </tr>
                    <tr>
                      <td>3. Sketch and concept</td>
                      <td>2 day</td>
                      <td>SAR 100</td>
                      <td>2%</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="lang-sec">
              <h6>Attachments</h6>
              <div className="images">
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/project/attachment-1.png`}
                  alt=""
                />
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/project/attachment-2.png`}
                  alt=""
                />
              </div>
            </div>
            <div className="submit-btn">
              <button className="btn">Decline offer</button>
              <button
                className="btn post-btn"
                onClick={() => navigate(`/${lan}/projectcontract/${posts.id}`)}
              >
                Accept offer
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="like-project">
            <div className="second-sec">
              <p>About the Client</p>
              <div className="second-sec">
                <p>About the Client</p>
                <h4>
                  {posts?.user?.first_name} {posts?.user?.last_name}
                </h4>

                <p>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/green-star.svg`}
                    alt=""
                  />&nbsp;&nbsp;
                  {posts?.user?.rating} ({posts?.user?.reviews} reviews)
                </p>
                <div className="members">
                  <p>Member since {getMemberSince(posts?.user?.created_on)} </p>
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/verified.svg`}
                      alt=""
                    />
                    Verified
                  </p>
                </div>
                <div className="members">
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/location.svg`}
                      alt=""
                    />
                    Location:
                  </p>
                  <p>{posts?.user?.country}</p>
                </div>
                <div className="members">
                <p>{posts?.user?.posts} {getPosttype(posts?.type)} posted</p>
                <p>{posts?.user?.active_posts} open {getPosttype(posts?.type)}</p>
                </div>
                <div className="members">
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/payment.svg`}
                      alt=""
                    />
                    Verified Payment
                  </p>
                </div>
              </div>
              <div className="members">
                <p>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/payment.svg`}
                    alt=""
                  />
                  Verified Payment
                </p>
              </div>
              <button className="btn">
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/project/client-chat.svg`}
                  alt=""
                />
                Chat with client
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
